module.exports = __webpack_public_path__ + "static/media/uomLogo.28083939.png";